import { useCallback } from 'react'
import useSubscribe from '@/utils/hooks/useSubscribe'
import { useForm } from '@/components/Inputs'
import {
  footerSocialFormInitValues,
  FooterSocialFormValues,
  footerSocialValidationSchema,
} from './Footer.social.schema'

export const useFooterSocialController = () => {
  const { onSubscribe, isLoading, subscribeMessage, closeSubscribeModal } = useSubscribe()

  const form = useForm<FooterSocialFormValues>({
    defaultValues: footerSocialFormInitValues,
    mode: 'all',
    schema: footerSocialValidationSchema,
  })

  const onSubscribeClick = useCallback(async () => {
    const isValid = await form.trigger()
    if (!isValid) return

    try {
      await onSubscribe({ data: form.getValues() })
      form.reset()
    } catch {
      // Subscription failures are surfaced to the user via subscribeMessage.
    }
  }, [form, onSubscribe])

  return {
    onSubscribeClick,
    form,
    isSubscribing: isLoading,
    subscribeMessage,
    closeSubscribeModal,
  }
}
